<script setup lang="ts">
import BaseMessage from '@/components/base/BaseMessage.vue';
</script>

<template>
  <BaseMessage class="mfa-warning" variant="warning" :closable="false">
    {{ $t('authentication.warning.requires-mfa') }}
    <RouterLink :to="`/settings/profile`">
      {{ $t('navigation.settings.my-profile') }}
    </RouterLink>
  </BaseMessage>
</template>
